import React from "react";

import classes from "./WhiteLabelCard.module.css";

interface Props {
  children: React.ReactNode;
  /** Grow to fill the parent flex section instead of hugging content. */
  fill?: boolean;
  padding?: string;
  className?: string;
}

/**
 * White card used across white-label report pages.
 *
 * Not the shared CustomCard: that one hardcodes width: 95% with margin: 0 auto
 * and a 20px radius, exposes no className, and only sets minHeight — so it
 * cannot shrink to fill a fixed-proportion flex section, which pages 3 and 4
 * depend on. Keeping one card component across all five pages also keeps the
 * corner radius consistent with the client's mock-up.
 */
const WhiteLabelCard = ({
  children,
  fill,
  padding,
  className,
}: Props): JSX.Element => (
  <div
    className={[classes.card, fill ? classes.fill : "", className ?? ""]
      .filter(Boolean)
      .join(" ")}
    style={padding ? { padding } : undefined}
  >
    {children}
  </div>
);

export default WhiteLabelCard;
